import { useText } from "@ignitesales/neuro-application/src/components/TextContext";
import { getMessageValue } from "@ignitesales/neuro-application/src/i18n/messageUtil";
import { parseAnswerValue } from "@ignitesales/neuro-application/src/util/questionUtil";
import classnames from "classnames";
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from "react-intl";

//TODO: refactor the render logic here to be in Neuro, but will also need to use the logic in the navigationReducer
const AnswersList = ({answers, className, filter, user}) => {
  const intl = useIntl();
  const cssBem = 'answersList';
  const textContext = useText();
  const classes = classnames(className, cssBem);
  const answersToFilter = filter || ['guideStartTime', 'guideEndTime', 'guideStarted'];

  const filterHiddenAndNullAnswers = ({appkey, view, value}) => {
    const hasValue = value !== null;
    const isHidden = view && view.attributes && view.attributes.hidden;
    const isSystemAppKey = answersToFilter.includes(appkey) || !view;
    return hasValue && !isHidden && !isSystemAppKey;
  };

  const renderAnswers = () => {
    const cssBEM = 'answer';

    const filteredAnswers = Object.entries(answers)
    /* eslint-disable-next-line no-unused-vars */
      .filter(([key, answer]) => filterHiddenAndNullAnswers(answer));

    /* eslint-disable-next-line no-unused-vars */
    const sortedAnswers = filteredAnswers.sort(([_, a], [_2, b]) => {
      return a.timestamp - b.timestamp;
    });

    //TODO: fix bug in Neuro where renderAnswer calls renderAnswers :-/
    return sortedAnswers.map(([key, answer]) => <div className={cssBEM} key={`${key}_${answer}`}>
      <h4 className={`${cssBEM}__key`}>
        {textContext?.[`details.${answer.appkey}`] || (
          <FormattedHTMLMessage id={ getMessageValue(intl.locale, `details.${answer.appkey}`) ? `details.${answer.appkey}` : answer.appkey } />
        )}
      </h4>
      <div className={`${cssBEM}__value`}>{parseAnswerValue(intl, answer, true)}</div>
      { answer?.pathKey && <a className={`${cssBEM}__edit`} href={`/guide/spa/${ user.uuid }/${ answer.pathKey }/${ answer.pageKey }`}><FormattedMessage id='editAnswer' /></a> }
    </div>);
  };

  return <div className={classes}>{renderAnswers()}</div>;
};

export default AnswersList;
